import React, { FC, useState } from 'react';
import cx from 'classnames';
import { map } from 'lodash';
import { Trans } from '@lingui/macro';
import { PropsWithClassName } from '@/types/common';
import Asset from '@/components/Common/Asset';
import Button, { ButtonVariant } from '@/components/Common/Button';
import * as styles from './LogosGrid.module.scss';

type Props = PropsWithClassName<{
  content: Queries.DatoCmsPartnerLogosCarouselFragment;
}>;

const LogosGrid: FC<Props> = ({ content, className }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { title, items } = content;
  const cards = items ?? [];
  return (
    <div
      className={cx(
        styles.main,
        {
          [styles.isExpanded]: isExpanded,
        },
        className
      )}
    >
      {title ? <h2 className={styles.title}>{title}</h2> : null}
      <div className={styles.cards}>
        {map(cards, (item, index) => (
          <div key={index} className={styles.card}>
            <Asset asset={item?.image} shouldUseCustomImage />
          </div>
        ))}
      </div>
      <Button
        className={styles.viewMore}
        variant={ButtonVariant.Bare}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        {isExpanded ? <Trans>- View less</Trans> : <Trans>+ View more</Trans>}
      </Button>
    </div>
  );
};

export default LogosGrid;
